import './main.less';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import renderViewsState from '../shared/render-views-state';
import Animate from '../shared/animation';
import { selectors as rootSelectors } from '../root';

import ManualApprove from './components/forms/manual-approve';
import RequestForApproveForm from './components/forms/request-for-approve';
import Table from './components/table/main';
import Filters from '../shared/filters/main';
import Calendar from '../shared/calendar/main';

const Main = renderViewsState(
	props => (
		<Animate>
			<div className="container__content conversions-approve-requests">
				<div className="container__content-title">
					<div className="container__content-title-position">
						<h1 className="title">{props.intl('Conversions approve requests')}</h1>
					</div>
				</div>
				<div className="container__content-body">
					<ManualApprove {...props} enableReinitialize={true} initialValues={props.manualApproveInitialValues} />
					<RequestForApproveForm {...props} />
					<div className="clearfix position-relative">
						<Filters {...props} {...props.filters} />
					</div>
					<div className="display-flex justify-content-flex-end">
						<div className="monthly-payments">
							<span className="monthly-payments__item">Выплаченые $ по командам</span>
							{
								props.monthlyPayments
									.filter(item => !!item.lead_email)
									.map((item, index) =>
										<span
											className="monthly-payments__item"
											key={index}
										>
											{item.lead_email}: ${item.payout_sum_usd}$
										</span>
									)
							}
						</div>
						<div className="ui-control-bar__item-position">
							<Calendar
								{...props.calendarOfCreationDate}
								onInit={props.calendarOfCreationDateInit}
								onToggle={props.calendarOfCreationDateToggle}
								onChange={props.calendarOfCreationDateChange}
								onApply={props.calendarOfCreationDateApply}
								intl={props.intl}
							/>
						</div>
						<div>
							<button
								className="ui-btn ui-btn-primary save margin-left-5"
								onClick={props.fetchData}
							>
								{props.intl('Apply')}
							</button>
						</div>
						<div>
							<button
								className="ui-btn ui-btn-primary save margin-left-5"
								onClick={props.getTeamsReport}
							>
								{props.intl('Teams export')}
							</button>
							<button
								className="ui-btn ui-btn-primary save margin-left-5"
								onClick={props.getReport}
							>
								{props.intl('Export')}
							</button>
						</div>
					</div>

					<Table {...props} />
				</div>
			</div>
		</Animate>
	),
	'view'
);

export default connect(
	state => ({
		data: selectors.getData(state),
		expandedRows: selectors.getExpandedRows(state),
		monthlyPayments: selectors.getMonthlyPayments(state),
		table: selectors.getTable(state),
		isRequestForApprovePopupVisible: selectors.getIsRequestForApprovePopupVisible(state),
		calendar: selectors.getCalendar(state),
		calendarOfCreationDate: selectors.getCalendarOfCreationDate(state),
		manualApproveInitialValues: selectors.getManualApproveInitialValues(state),
		menuConfig: rootSelectors.getMenuConfig(state),
		progressBar: selectors.getProgressBar(state),
		intl: selectors.getIntl(state),
		reasons: selectors.getReasons(state),
		filters: selectors.getFilters(state),
		can: selectors.getCan(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/conversions-approve-requests/main.js